import React from 'react';
import Customer from '@/views/pages/Customer';
import Dashboard from '@/views/pages/Dashboard';
import Versions from '@/views/pages/versions';
import Payout from '@/views/pages/Payout';
import Report from '@/views/pages/Report';
import Categories from '@/views/pages/Categories';
import AddCategorie from '@/views/pages/AddCategorie';
import B2BCategories from '@/views/pages/B2BCategories';
import B2BCommissionRates from '@/views/pages/B2BCommissionRates';
import TaskerCategories from '@/views/pages/TaskerCategories';
import AddTaskerCategory from '@/views/pages/AddTaskerCategory';
import TaskerTemplate from '@/views/pages/TaskerTemplate';
import CustomerDetails from '@/views/pages/CustomerDetails';
import taskDetails from '@/views/pages/taskDetails';
import Tasker from '@/views/pages/Tasker';
import ApproveTasker from '@/views/pages/ApproveTasker';
import TaskerDateil from '@/views/pages/TaskerDateil';
import Chat from '@/views/pages/Chat/Chat';
import DeleteTasker from '@/views/deleteTasker/deleteTasker';
import Tasks from '@/views/pages/tasks';
import OnlineCoupons from '@/views/pages/coupons/online-coupons';
import CouponDetail from '@/views/pages/coupons/coupon-detail';
import VoucherCodes from '@/views/pages/coupons/voucher-codes';
import VoucherCodeInfo from '@/views/pages/coupons/voucher-code-info';
import OnlineCouponInfo from '@/views/pages/coupons/online-coupon-info';
import BusinessAdminUser from '@/views/pages/BusinessAdminUser';
import BusinessAdminJobs from '@/views/pages/BusinessAdminJobs';
import TaskApprovals from '@/views/pages/TaskApprovals';
import BusinessAdminInvoices from '@/views/pages/BusinessAdminInvoices';
const Login = React.lazy(() => import('@/views/login'));
const Index = React.lazy(() => import('@/views/pages/index'));
const ResetPassword = React.lazy(() => import('@/views/resetPassword'));
export interface RouteConfigDeclaration {
    path: string;
    name?: string;
    exact?: boolean;
    auth?: boolean;
    isRedirect?: boolean;
    isDynamic?: boolean;
    loadingFallback?: string;
    component: any;
    childrens?: RouteConfigDeclaration[];
    KeepAlive?: boolean;
}
const routes: RouteConfigDeclaration[] = [
    {
        path: '/login',
        component: Login,
        exact: true,
        auth: false,
    },
    {
        path: '/resetPassword',
        component: ResetPassword,
        exact: true,
        auth: false,
    },
    {
        path: '/delete-account',
        component: DeleteTasker,
        exact: true,
        auth: false,
    },
    {
        path: '/*',
        component: Index,
        exact: false,
        childrens: [
            {
                path: '/dashboard',
                name: 'Dashboard',
                component: Dashboard,
                exact: true,
            },
            {
                path: '/business-admin-user',
                name: 'BusinessAdminUser',
                component: BusinessAdminUser,
                exact: true,
                KeepAlive: true,
            },
            {
                path: '/task-approvals',
                name: 'TaskApprovals',
                component: TaskApprovals,
                exact: true,
                KeepAlive: true,
            },
            {
                path: '/business-admin-jobs',
                name: 'BusinessAdminJobs',
                component: BusinessAdminJobs,
                exact: true,
                KeepAlive: true,
            },
            {
                path: '/b2b-commission',
                name: 'B2BCommissionRates',
                component: B2BCommissionRates,
                exact: true,
                KeepAlive: true,
            },
            {
                path: '/business-admin-invoices',
                name: 'BusinessAdminInvoices',
                component: BusinessAdminInvoices,
                exact: true,
                KeepAlive: true,
            },
            {
                path: '/customer',
                name: 'Customer',
                component: Customer,
                exact: true,
                KeepAlive: true,
            },
            {
                path: '/customer/detail',
                name: 'CustomerDetails',
                component: CustomerDetails,
                exact: true,
                KeepAlive: true,
            },
            {
                path: '/task/detail',
                name: 'taskDetails',
                component: taskDetails,
                exact: true,
            },
            {
                path: '/tasker',
                name: 'Tasker',
                component: Tasker,
                exact: true,
                KeepAlive: true,
            },
            {
                path: '/approve-tasker',
                name: 'ApproveTasker',
                component: ApproveTasker,
                exact: true,
                KeepAlive: true,
            },
            {
                path: '/tasker/detail',
                name: 'TaskerDateil',
                component: TaskerDateil,
                exact: true,
                KeepAlive: true,
            },
            {
                path: '/tasks',
                name: 'tasks',
                component: Tasks,
                exact: true,
                KeepAlive: true,
            },
            {
                path: '/user/chat',
                name: 'userChat',
                component: Chat,
                exact: true,
            },
            {
                path: '/report',
                name: 'Report',
                component: Report,
                exact: true,
            },
            {
                path: '/payout',
                name: 'Payout',
                component: Payout,
                exact: true,
            },
            {
                path: '/categories',
                name: 'Categories',
                component: Categories,
                exact: true,
            },
            {
                path: '/categories/add',
                name: 'AddCategorie',
                component: AddCategorie,
                exact: true,
            },
            {
                path: '/b2b-categories',
                name: 'B2BCategories',
                component: B2BCategories,
                exact: true,
            },
            {
                path: '/tasker-categories',
                name: 'TaskerCategories',
                component: TaskerCategories,
                exact: true,
            },
            {
                path: '/tasker-categories/add',
                name: 'AddTaskerCategory',
                component: AddTaskerCategory,
                exact: true,
            },
            {
                path: '/tasker-template',
                name: 'TaskerTemplate',
                component: TaskerTemplate,
                exact: true,
            },
            {
                path: '/version',
                name: 'Version',
                component: Versions,
                exact: true,
            },
            {
                path: '/online-coupons',
                name: 'OnlineCoupons',
                component: OnlineCoupons,
                exact: true,
                KeepAlive: true,
            },
            {
                path: '/online-coupon-info',
                name: 'OnlineCouponInfo',
                component: OnlineCouponInfo,
                exact: true,
            },
            {
                path: '/coupon-detail',
                name: 'CouponDetail',
                component: CouponDetail,
                exact: true,
            },
            {
                path: '/voucher-codes',
                name: 'VoucherCodes',
                component: VoucherCodes,
                exact: true,
                KeepAlive: true,
            },
            {
                path: '/voucher-code-info',
                name: 'VoucherCodeInfo',
                component: VoucherCodeInfo,
                exact: true,
            },
        ],
    },
];

export default routes;
